import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputRegexDirective } from './input-regex.directive';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    InputRegexDirective
  ],
  imports: [
    CommonModule,
    FormsModule,
  ],
  exports: [
    InputRegexDirective
  ]
})
export class InputRegexModule { }
